"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mobiledoc_1 = require("../types/Mobiledoc");
var MarkupSectionRenderer_1 = require("./MarkupSectionRenderer");
var ImageSectionRenderer_1 = require("./ImageSectionRenderer");
var ListSectionRenderer_1 = require("./ListSectionRenderer");
var CardSectionRenderer_1 = require("./CardSectionRenderer");
exports.default = (function (_a) {
    var createElement = _a.createElement, getCardComponent = _a.getCardComponent, getAtomComponent = _a.getAtomComponent, getMarkupComponent = _a.getMarkupComponent;
    return function (_a) {
        var markups = _a.markups, cards = _a.cards, atoms = _a.atoms;
        return function (section) {
            var _a;
            return ((_a = {},
                _a[Mobiledoc_1.SectionTypeIdentifier.MARKUP] = MarkupSectionRenderer_1.default({
                    createElement: createElement,
                    getAtomComponent: getAtomComponent,
                    getMarkupComponent: getMarkupComponent
                })({ markups: markups, atoms: atoms }),
                _a[Mobiledoc_1.SectionTypeIdentifier.IMAGE] = ImageSectionRenderer_1.default({
                    createElement: createElement,
                    getMarkupComponent: getMarkupComponent
                }),
                _a[Mobiledoc_1.SectionTypeIdentifier.LIST] = ListSectionRenderer_1.default({
                    createElement: createElement,
                    getAtomComponent: getAtomComponent,
                    getMarkupComponent: getMarkupComponent
                })({ markups: markups, atoms: atoms }),
                _a[Mobiledoc_1.SectionTypeIdentifier.CARD] = CardSectionRenderer_1.default({
                    createElement: createElement,
                    getCardComponent: getCardComponent
                })({ cards: cards }),
                _a)[section[0]](section));
        };
    };
});
